import axiosAuth from '../../axiosMain';

async function index(filters = {}) {
  let response = await axiosAuth.get('/suggestions', { params: filters });
  return response.data;
}

async function show(suggestionId) {
  let response = await axiosAuth.get(`/suggestions/${suggestionId}`);
  return response.data;
}

export default {
  index,
  show,
};
